import { render } from "./AdminLocationsProfile.vue?vue&type=template&id=6f3e472f"
import script from "./AdminLocationsProfile.vue?vue&type=script&lang=js"
export * from "./AdminLocationsProfile.vue?vue&type=script&lang=js"

import exportComponent from "/home/sensores-test/frontendv2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__